import { fetchFromObject } from 'helpers/object';
// import { lsGetSelectedCommonFilters } from 'helpers/store';

export default {
  dataUI: state => field => fetchFromObject(state, field)
  // commonFilters: state => filter =>
  //   state.commonFilters[filter] || lsGetSelectedCommonFilters(filter)
};
